import * as types from './constants.jsx';

export function setPriceListInfo(data) {
    return {
        type: types.SET_PRICE_LIST_INFO,
        data
    }
}
